/**
 * ms-brand-directory — buscador del directorio de marcas (sections/ms-brand-directory.liquid).
 * Filtra la lista mientras se escribe (sin acentos ni mayúsculas) y actualiza el
 * contador. Sin JavaScript la lista completa sigue ahí: esto solo la acorta.
 */
if (!customElements.get('ms-brand-directory')) {
  customElements.define(
    'ms-brand-directory',
    class MsBrandDirectory extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        const input = this.querySelector('[data-ms-brand-search]');
        const status = this.querySelector('[data-ms-brand-count]');
        const empty = this.querySelector('[data-ms-brand-empty]');
        const items = [...this.querySelectorAll('[data-ms-brand-name]')];
        if (!input || !status || !empty) return;

        const normalize = (value) =>
          value.normalize('NFD').replace(/[̀-ͯ]/g, '').toLocaleLowerCase().trim();
        const names = items.map((item) => normalize(item.dataset.msBrandName || ''));
        const label = this.dataset.countLabel || '';

        const filter = () => {
          const query = normalize(input.value);
          let count = 0;
          items.forEach((item, i) => {
            const show = names[i].includes(query);
            item.hidden = !show;
            if (show) count += 1;
          });
          status.textContent = `${label} ${count}`.trim();
          empty.hidden = count !== 0;
        };

        input.addEventListener('input', filter);
        input.addEventListener('search', filter);
        if (input.value) filter();
      }
    }
  );
}
